import { Entry } from 'contentful'

export const parseConfigurableEmbed = (
  configurableEmbedEntry: Entry<{
    name: string
    embedSourceUrl: string
  }>
): {
  componentKey: string
  embedSourceUrl: string
} => {
  const embed = {
    componentKey: 'configurableEmbed',
    ...configurableEmbedEntry?.fields,
  }

  return embed
}
